(function () {
  function init() {
    var bar = document.querySelector('[data-apparel-filter-bar]');
    if (!bar) return;

    var header = document.querySelector('header.theme__header') || document.querySelector('header');

    function setHeaderHeight() {
      if (header) {
        document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
      }
    }
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    var buttons = bar.querySelectorAll('[data-filter-value]');
    var dropSections = document.querySelectorAll('.apparel-drop');
    var filteredGrid = document.querySelector('[data-apparel-filtered-grid]');
    var filteredRow = document.querySelector('[data-apparel-filtered-grid-row]');
    var allCells = Array.prototype.slice.call(document.querySelectorAll('.apparel-drop__product-cell'));

    // Remember each cell's original position so we can restore it later.
    var originalParent = new Map();
    var originalNext = new Map();
    allCells.forEach(function (cell) {
      originalParent.set(cell, cell.parentNode);
      originalNext.set(cell, cell.nextSibling);
    });

    function restoreCells() {
      allCells.forEach(function (cell) {
        var parent = originalParent.get(cell);
        var next = originalNext.get(cell);
        if (!parent) return;
        if (next && next.parentNode === parent) {
          parent.insertBefore(cell, next);
        } else {
          parent.appendChild(cell);
        }
        cell.style.display = '';
      });
    }

    function applyFilter(value) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-filter-value') === value);
      });

      var isFiltered = value !== 'all';

      if (!isFiltered) {
        restoreCells();

        dropSections.forEach(function (section) {
          section.style.display = '';
          var hero = section.querySelector('.apparel-drop__hero-cell');
          if (hero) hero.style.display = '';
        });

        if (filteredGrid) filteredGrid.classList.remove('is-active');
        return;
      }

      dropSections.forEach(function (section) {
        section.style.display = 'none';
      });

      if (filteredRow) {
        allCells.forEach(function (cell) {
          var type = cell.getAttribute('data-product-type');
          if (type === value) {
            filteredRow.appendChild(cell);
            cell.style.display = '';
          } else {
            cell.style.display = 'none';
          }
        });
      }

      if (filteredGrid) filteredGrid.classList.add('is-active');
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-filter-value'));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
